import apiClient from "@/shared/api/apiClient2";

export const getTariffListNotarialItem = async (id, params) => {
  try {
    const { data } = await apiClient.post(
      `/calculations/notary-transaction-price/${id}`,
      {
        ...params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("getTariffListNotarialItem failed", e);
  }
};

export const bindingFinishPriceNotarial = async (id, payload) => {
  try {
    const { data } = await apiClient.post(
      `/calculations/notary-transaction-finish-price/${id}/`,
      {
        ...payload,
      }
    );
    return data;
  } catch (e) {
    console.error("bindingFinishPriceNotarial failed", e);
  }
};

export const getNotarialPreferentialTariffList = async (id) => {
  try {
    const { data } = await apiClient.get(
      "/calculations/notary-transaction-preferential-tariff/" + id
    );
    return data;
  } catch (e) {
    console.error("getNotarialPreferentialTariffList failed", e);
  }
};

export const getNotarialTariffSaved = async (id) => {
  try {
    const { data } = await apiClient.get(
      `/calculations/notary-transaction-price/${id}/`
    );
    return data;
  } catch (e) {
    console.error("getNotarialTariffSaved failed", e);
  }
};

export const getHiddenFields = async (id) => {
  try {
    const { data } = await apiClient.get(`/calculations/hidden_fields/${id}/`);
    return data;
  } catch (e) {
    console.error("getHiddenFields failed", e);
  }
};
